import { useTranslation } from "react-i18next";
import { ANNOUNCEMENTS_PLATFORM_FILTER_ENUM } from "@/utils/enums/announcement.enum";
import clsx from "clsx";

/** `value` is the enum contract; `label` is a lookup key resolved at render. */
const ANNOUNCEMENTS_TABS = [
  { label: "nav:tabs.all", value: ANNOUNCEMENTS_PLATFORM_FILTER_ENUM.ALL },
  {
    label: "nav:tabs.unread",
    value: ANNOUNCEMENTS_PLATFORM_FILTER_ENUM.UNREAD,
  },
];

interface IProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  unreadCount: number;
}

export const AnnouncementsTabs = ({
  activeTab,
  setActiveTab,
  unreadCount,
}: IProps) => {
  const { t } = useTranslation(["common", "nav"]);

  return (
    <div className="flex gap-1 px-3 py-2 border-b overflow-x-auto scrollbar-hidden">
      {ANNOUNCEMENTS_TABS.map((tab) => {
        const isActive = activeTab === tab.value;
        const isUnreadTab =
          tab.value === ANNOUNCEMENTS_PLATFORM_FILTER_ENUM.UNREAD;

        return (
          <button
            key={tab.value}
            onClick={() => setActiveTab(tab.value)}
            className={clsx(
              "shrink-0 flex items-center gap-1 rounded-md px-2.5 py-1 text-[11px] font-medium transition-all duration-150",
              isActive
                ? "bg-primary/15 text-primary"
                : "text-muted-foreground hover:bg-muted hover:text-foreground",
            )}
          >
            {t(tab.label)}
            {isUnreadTab && unreadCount > 0 && (
              <span className="inline-flex items-center justify-center h-[14px] min-w-[14px] rounded-full bg-primary text-white text-[8px] font-bold px-1 leading-none">
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
